import './HotelCard.scss';
import * as React from 'react';
import { SearchResultHotel } from 'src/state/SearchResult';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';
import { IconStar } from 'src/components/Icon/IconStar';
import { IconCrown } from 'src/components/Icon/IconCrown';
import { IconLocation } from 'src/components/Icon/IconLocation';
import { IconChevronRight } from 'src/components/Icon/IconChevronRight';
import { ResponsiveImage } from 'src/components/ResponsiveImage';
import { FormattedMessage } from 'react-intl';

type Props = {
    readonly modificators?: ReadonlyArray<string>;
    readonly variant?: string;
    readonly searchItem: SearchResultHotel;
};

export function HotelCard(props: Props): JSX.Element {
    const { modificators = [], variant, searchItem } = props;

    return (
        <a href={searchItem.searchItem.url}
           target="_blank"
           className={classList(getClasses('lvo-hotel-card', modificators), variant)}>
            <div className="lvo-hotel-card__img-container lvo-hotel-card__img--bottom">
                <div className="lvo-hotel-card__img">
                    <ResponsiveImage src={searchItem.searchItem.image}/>
                </div>
            </div>
            <div className="lvo-hotel-card__info-wrapper">
                {searchItem.hotelStars !== null && searchItem.hotelStars > 0 && (
                    <div className="lvo-hotel-card__stars">
                        {Array(searchItem.hotelStars).fill(null).map((_, index) => (
                            <div key={index} className="icon-box">
                                <IconStar/>
                            </div>
                        ))}
                        {searchItem.hotelIsSuperior && (
                            <div className="icon-box">
                                <IconCrown/>
                            </div>
                        )}
                    </div>
                )}
                <h4 className="lvo-hotel-card__title">
                    {searchItem.searchItem.title}
                </h4>

                {searchItem.hotelLocation && (
                    <div className="lvo-hotel-card__location">
                        <div className="icon-box">
                            <IconLocation/>
                        </div>
                        {searchItem.hotelLocation}
                    </div>
                )}

                <div className="lvo-hotel-card__description">
                    {searchItem.searchItem.description}
                </div>
                <div className="lvo-hotel-card__link">
                    <div className="icon-box">
                        <IconChevronRight/>
                    </div>
                    <FormattedMessage id="searchPage_readMore"/>
                </div>
            </div>
        </a>
    );
}
